import React, { useState } from 'react';
import MasterLayout from '../components/layouts/MasterLayout';
import ProductList from '../components/products/ProductList';
import MainSearch from '../components/search/MainSearch';
import { useParams } from 'react-router-dom';

const CategoryPage = () => {
    const { categoryName } = useParams();

    const [filteredData, setFilteredData] = useState({ category: categoryName }); 


    const updateFilteredData = (data) => {
        setFilteredData(data);
    }

    return (
        <MasterLayout>
            <MainSearch onUpdateFilteredData={updateFilteredData} />
            <ProductList filteredData={filteredData} sectionTitle={categoryName} loadMore={true} collectionData={{isCollection:false , name:'product'}}/>
        </MasterLayout>
    );
};

export default CategoryPage;
